import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/Logo D.png";

export default function Footer() {
  const navigate = useNavigate();

  // Function to navigate and scroll to top
  const handleScrollToTop = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        body {
          overflow-x: hidden;
        }

        .footer {
          width: 100%;
          background: #ffffff;
          color: #555;
          padding: 60px 20px;
          border-top: 1px solid #e5e5e5;
          font-family: Arial, sans-serif;
        }

        .footer-container {
          display: flex;
          flex-wrap: wrap;
          gap: 40px;
          justify-content: space-between;
          max-width: 1200px;
          margin: 0 auto;
        }

        .footer-section {
          flex: 1 1 250px;
          min-width: 250px;
        }

        .footer-logo {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 15px;
        }

        .logo-text {
          font-size: clamp(10px, 4vw, 18px);
          color: #1b7a9fff;
          font-weight: bold;
        }

        .footer-description {
          font-size: 14px;
          line-height: 1.8;
          max-width: 100%;
          margin-bottom: 20px;
          color: #444;
        }

        .footer-links {
          display: flex;
          flex-direction: column;
        }

        .footer-link {
          font-size: 14px;
          margin-bottom: 8px;
          color: #555;
          text-decoration: none;
          transition: color 0.2s ease;
          cursor: pointer;
        }

        .footer-link:hover {
          color: #1b7a9fff;
        }

        .social-icons {
          display: flex;
          gap: 12px;
        }

        .social-icon-img {
          width: 40px;
          height: 40px;
          background: #eef2ff;
          padding: 8px;
          border-radius: 50%;
          cursor: pointer;
          transition: transform 0.2s ease, background 0.2s ease;
        }

        .social-icon-img:hover {
          transform: scale(1.1);
          background: #dce2ff;
        }

        .footer-title {
          font-size: 20px;
          margin-bottom: 15px;
          font-weight: bold;
          color: #333;
        }

        .footer-list {
          list-style: none;
          padding: 0;
        }

        .footer-list li {
          font-size: 14px;
          margin-bottom: 8px;
          color: #555;
          transition: color 0.2s ease;
        }

        .footer-list li:hover {
          color: #1b7a9fff;
          cursor: pointer;
        }

        .footer-phone {
          font-size: 20px;
          color: #1b7a9fff;
          font-weight: bold;
        }

        .footer-email,
        .footer-address {
          font-size: 14px;
          margin-top: 5px;
          color: #555;
        }

        .footer-bottom {
          text-align: center;
          font-size: 14px;
          margin-top: 50px;
          color: #888;
        }

        /* WhatsApp Sticky Button */
        .whatsapp-button {
          position: fixed;
          bottom: 20px;
          right: 20px;
          width: 60px;
          height: 60px;
          background: #25D366;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 12px rgba(0,0,0,0.3);
          cursor: pointer;
          z-index: 1000;
          transition: transform 0.2s ease;
        }

        .whatsapp-button:hover {
          transform: scale(1.1);
        }

        .whatsapp-button img {
          width: 32px;
          height: 32px;
        }

        /* Responsive */
        @media(max-width: 768px) {
          .footer-container {
            flex-direction: column;
            align-items: flex-start;
          }

          .footer-section {
            width: 100%;
          }

          .social-icons {
            justify-content: flex-start;
          }
        }
      `}</style>

      <footer className="footer">
        <div className="footer-container">
          {/* Logo + Description */}
          <div className="footer-section">
            <div className="footer-logo">
              <img
                src={logo}
                alt="Rapid Wash Logo"
                style={{ width: "120px", height: "100px", objectFit: "contain" }}
              />
              <h5 className="logo-text">Rapid Wash Laundry & Dry Cleaning Services</h5>
            </div>

            <p className="footer-description">
              At Rapid Wash, we provide premium laundry and dry cleaning services with exceptional care and attention to detail.
              Fresh, crisp, and professionally handled garments, every time.
            </p>

            <div className="social-icons">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2504/2504947.png"
                alt="Twitter"
                className="social-icon-img"
              />
              <img
                src="https://cdn-icons-png.flaticon.com/512/2504/2504903.png"
                alt="Facebook"
                className="social-icon-img"
              />
              <img
                src="https://cdn-icons-png.flaticon.com/512/2504/2504918.png"
                alt="Instagram"
                className="social-icon-img"
              />
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <div className="footer-links">
              <span onClick={() => handleScrollToTop("/")} className="footer-link">Home</span>
              <span onClick={() => handleScrollToTop("/about")} className="footer-link">About</span>
              <span onClick={() => handleScrollToTop("/services")} className="footer-link">Services</span>
              <span onClick={() => handleScrollToTop("/pricing")} className="footer-link">Pricing</span>
              <span onClick={() => handleScrollToTop("/contact")} className="footer-link">Contact</span>
            </div>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h3 className="footer-title">Our Services</h3>
            <ul className="footer-list">
              <li>Premium Dry Cleaning</li>
              <li>Garment Ironing & Pressing</li>
              <li>Laundry Pickup & Delivery</li>
              <li>Express Laundry Service</li>
              <li>App-based Order & Tracking</li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h3 className="footer-title">Contact Us</h3>
            <p className="footer-phone">(+91) 93151 25347</p>
            <p className="footer-email">info@rapidwash.co.in</p>
            <p className="footer-address">
              Gate No. 4, Metro station, Block K, Hauz Khas Enclave, Hauz Khas, New Delhi, Delhi - 110016
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} Rapid Wash Laundry & Dry Cleaning Services. All rights reserved.
        </div>
      </footer>

      <a
        href="https://wa.me/919315125347"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-button"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/124/124034.png"
          alt="WhatsApp"
        />
      </a>
    </>
  );
}
